import { apiFetch } from "../http";
export async function loginUser(params) {
    const { baseUrl, email, password, referralCode, signal } = params;
    return apiFetch(`/user/api/user/login/`, {
        baseUrl,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({
            email,
            password,
            ...((referralCode === null || referralCode === void 0 ? void 0 : referralCode.trim()) ? { referral_code: referralCode.trim() } : {}),
        }),
        signal,
        redirectOnUnauthorized: false,
    });
}
export async function registerUser(params) {
    const { baseUrl, email, username, password, passwordConfirmation, referralCode, signal, } = params;
    return apiFetch(`/user/api/user/create_user/`, {
        baseUrl,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({
            email,
            username,
            password,
            password_confirmation: passwordConfirmation,
            ...(referralCode ? { referral_code: referralCode } : {}),
        }),
        signal,
        redirectOnUnauthorized: false,
    });
}
export async function getCurrentUser(params) {
    return apiFetch(`/user/api/user/me/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
        headers: { Accept: "application/json" },
        signal: params.signal,
        notifyOnUnauthorized: params.notifyOnUnauthorized,
        requestTimeoutMs: params.requestTimeoutMs,
        redirectOnUnauthorized: false,
    });
}
export async function resendConfirmationEmail(params) {
    return apiFetch(`/user/api/resend_confirm_email/`, {
        baseUrl: params.baseUrl,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({ email: params.email }),
        signal: params.signal,
        redirectOnUnauthorized: false,
    });
}
export async function sendPresenceHeartbeat(params) {
    const { baseUrl, token, clientType = "web", signal } = params;
    return apiFetch(`/user/api/presence/heartbeat/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ client_type: clientType, ...(params.installation ? { installation: params.installation } : {}) }),
        signal,
        redirectOnUnauthorized: false,
    });
}
